import { render } from "./CancellationFailure.vue?vue&type=template&id=0f6f2a63"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__